import { InQueueWidget } from '@src/widgets/ActionPaths';
import { DataContainment } from '@src/widgets/RiskRecords/DataContainment';
import { DobUntrustedSources } from '@src/widgets/RiskRecords/DobUntrustedSources';
import { Events } from '@src/widgets/RiskRecords/Events';
import { RiskCodes } from '@src/widgets/RiskRecords/RiskCodes';
import { SsnUntrustedSources } from '@src/widgets/RiskRecords/SsnUntrustedSources';
import { UntrustedSourceRecords } from '@src/widgets/RiskRecords/UntrustedSourceRecords';

/**
 * widgets
 *
 * @type {{dataCollision: {component: ((function(*): Element)|*), accessor: string, icon: string, description: string,
 *     title: string, order: number}, dobUntrustedSources: {component: ((function(*): Element)|*), accessor: string,
 *     icon: string, description: string, title: string, order: number}, ssnUntrustedSources: {component:
 *     ((function(*): Element)|*), accessor: string, icon: string, description: string, title: string, order: number},
 *     untrustedSourceRecords: {component: ((function(*): Element)|*), accessor: string, icon: string, description:
 *     string, title: string, order: number}, riskCodes: {component: ((function(*): Element)|*), accessor: string,
 *     icon: string, description: string, title: string, order: number}, events: {component: ((function(*):
 *     Element)|*), accessor: string, icon: string, description: string, title: string, order: number}}}
 */
export const widgets = {
  dataCollision: {
    accessor: 'dataCollision',
    component: InQueueWidget,
    description: 'In queue statuses',
    icon: 'dataset',
    order: 6,
    title: 'Data Collision',
  },
  dataContainment: {
    accessor: 'dataContainment',
    component: DataContainment,
    description: '',
    icon: 'data_array',
    order: 4,
    title: 'Data Containment',
  },
  dobUntrustedSources: {
    accessor: 'dobUntrustedSources',
    component: DobUntrustedSources,
    description: 'Total volume of source records that do not match IRE Trusted DOB',
    icon: 'attribution',
    order: 3,
    title: 'DOB Untrusted Sources',
  },
  events: {
    accessor: 'events',
    component: Events,
    description: '',
    icon: 'timeline',
    order: 7,
    title: 'Events',
  },
  riskCodes: {
    accessor: 'riskCodes',
    component: RiskCodes,
    description: 'Count of Enterprise Ids associated with IRE risk code',
    icon: 'code',
    order: 1,
    title: 'Risk Codes',
  },
  ssnUntrustedSources: {
    accessor: 'ssnUntrustedSources',
    component: SsnUntrustedSources,
    description: 'Total volume of source records that do not match IRE Trusted SSN',
    icon: 'numbers',
    order: 5,
    title: 'SSN Untrusted Sources',
  },
  untrustedSourceRecords: {
    accessor: 'untrustedSourceRecords',
    component: UntrustedSourceRecords,
    description: 'Records by source that are with an action path or without',
    icon: 'error',
    order: 2,
    title: 'Untrusted Source Records',
  },
};
